import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M25.0417 7.875V2.91667C25.0417 2.1375 24.2729 1.5 23.3333 1.5H2.83333C1.89375 1.5 1.125 2.1375 1.125 2.91667V17.0833C1.125 17.8625 1.89375 18.5 2.83333 18.5H23.3333C24.2729 18.5 25.0417 17.8625 25.0417 17.0833V12.125L28.9538 15.3692C30.03 16.2617 31.875 15.6242 31.875 14.3633V5.6225C31.875 4.36167 30.03 3.72417 28.9538 4.61667L25.0417 7.875Z";

export default function VideoRecordIcon(props: IconProps) {
  return <SVGIcon path={path} viewBox="0 0 30 20" {...props} />;
}
